<block-ui [template]="blockTemplate">

  <app-header> </app-header>
  <section class="feature-medicine-section mt-5" style="background-color: #f2f2f2 0% 0% no-repeat padding-box">
    <div class=" container ">
      <div class="row   justify-content-center">
        <div class=" container mt-4  row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="text-center text-lg-left">
              <div style="
                        margin-top: 7px;
                        background-color: transparent;
                        margin-bottom: 27px;
                        
                    "><i class="mr-1 mobile-icon-title">
                  <img src="../../../../assets/app-assets/images/icones-geia/Grupo-434.png" width="55px"></i>
                <h4 *ngIf="!heGrandeEmpresa" class="ml-5 mobile-title-tipo-empresa" style="margin-top: -15px;
                                    font-size: 27px;
                                    line-height: 0.3;
                                    font-weight: 600;
                                    padding-left: 5px;">PEQUENAS E MÉDIAS EMPRESAS</h4>

                <h4 *ngIf="heGrandeEmpresa" class="ml-5 mobile-title-tipo-empresa" style="margin-top: -15px;
                                    font-size: 27px;
                                    line-height: 0.3;
                                    font-weight: 600;
                                    padding-left: 5px;">EMPRESAS</h4>


              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center">


          </div>
          <div class="col-lg-6 col-md-6 d-none d-sm-none d-md-none d-lg-block order-lg-prev">
            <div class="card custom-card">
              <div class="card-body">
                <div class="tile-gallery-three">
                  <div class="image-one" style="   margin: -22px 0;">
                    <img src="../../../../assets/app-assets/images/ilustracao/iris-geia-polo.png" alt="Image"
                      class="img-fluid" style=" 
                                      margin: 0 -10% 0;
                                  ">
                  </div>
                </div>

              </div>
            </div>
            <p *ngIf="!heGrandeEmpresa" class="mt-1 mb-3">
              Utilize seu <b>CNPJ</b> e tenha acesso a <b>planos exclusivos</b> com descontos especiais. A Géia te ajuda
              a encontrar o plano ideal para a sua empresa.
            </p>
            <p *ngIf="heGrandeEmpresa" class="mt-1 mb-3">
              Oferecer um <b>Plano de Saúde</b> de qualidade é um <b>compromisso</b> com o <b>bem estar</b> e a
              produtividade da sua equipe. A Géia entende as demandas da sua empresa e oferece soluções completas.
            </p>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-10 conta">
            <div class="feature-content pr-xl-5 ">
              <div class="section-heading text-center heading-white container">
                <h2 class="title-cotacao text-rigth mb-1">
                  Preencha com os dados da sua empresa
                </h2>
              </div>
              <form [formGroup]="formNovaCotacao" (ngSubmit)="onSubmit()" class="form row">
                <div class="form-group col-md-12 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input required name="fullName" type="text" id="fullName" maxlength="50" formControlName="fullName"
                      [ngClass]="{
                        'is-invalid':
                        formNovaCotacao.controls['fullName'].errors &&
                          formSubmitted
                      }" placeholder="Nome" class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-user"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['fullName'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>
                  </fieldset>
                </div>

                <div class="form-group col-md-6 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input name="telephoneNumber" type="tel" id="telephoneNumber" mask="(00) 00000-0000"
                      [showMaskTyped]="true" formControlName="telephoneNumber" placeholder="Informe o Celular"
                      [ngClass]="{'is-invalid': formNovaCotacao.controls['telephoneNumber'].errors &&  formSubmitted}"
                      class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-phone"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['telephoneNumber'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>
                  </fieldset>
                </div>
                <div class="form-group col-md-6 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input name="email" type="text" id="user-email" maxlength="60" formControlName="email"
                      [ngClass]="{'is-invalid': formNovaCotacao.controls['email'].errors &&  formSubmitted}"
                      placeholder="E-mail" class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-envelope-o"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['email'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>

                  </fieldset>
                </div>

                <div class="form-group col-md-12 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input name="Nome da Empresa" type="text" id="empresa" maxlength="60" formControlName="companyName"
                      [ngClass]="{'is-invalid': formNovaCotacao.controls['companyName'].errors &&  formSubmitted}"
                      placeholder="Nome da empresa" class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-building-o"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['companyName'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>

                  </fieldset>
                </div>
                <div class="form-group col-md-6 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input mask="9*" maxlength="5" name="Total de funcionário(s)" type="text" OnlyNumber="true" id="NumberOfEmployees"  
                      formControlName="numberOfEmployees"
                      [ngClass]="{'is-invalid': formNovaCotacao.controls['numberOfEmployees'].errors &&  formSubmitted}"
                      placeholder="Total de funcionário(s)"
                      class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-user"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['numberOfEmployees'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>
                  </fieldset>
                </div>
                <div class="form-group col-md-6 rem-mb-form">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input class="form-control round" name="cnpj" mask="00.000.000/0000-00" [showMaskTyped]="true"
                      id="cnpj" formControlName="cnpj"
                      [ngClass]="{'is-invalid': formNovaCotacao.controls['cnpj'].errors &&  formSubmitted}"
                      placeholder="cnpj" class="form-control border-radius ng-dirty ng-valid ng-touched" />
                    <div class="form-control-position mr-t-icon">
                      <i class="fa fa-company-o"></i>
                    </div>
                    <div *ngIf="formNovaCotacao.controls['cnpj'].errors?.['required'] && formSubmitted"
                      class="invalid-feedback">
                      Campo obrigatório
                    </div>


                  </fieldset>
                </div>

                <div class="form-group round col-md-12 rem-mb-form">
                  <ng-select class="round bg-white shadow" [multiple]="false" [searchable]="true"
                    formControlName="howMetGeia" placeholder="Como conheceu a Géia?">
                    <ng-option [value]="'instagram'">Instagram</ng-option>
                    <ng-option [value]="'facebook'">Facebook</ng-option>
                    <ng-option [value]="'google'">Google</ng-option>
                    <ng-option [value]="'tiktok'">Tiktok</ng-option>
                    <ng-option [value]="'linkedin'">LinkedIn</ng-option>
                    <ng-option [value]="'youtube'">YouTube</ng-option>
                    <ng-option [value]="'outro'">Outro</ng-option>
                  </ng-select>

                  <div *ngIf="formNovaCotacao.controls['howMetGeia'].errors?.['required'] && formSubmitted"
                    class="invalid-feedback d-block">
                    Campo obrigatório
                  </div>
                </div>
                <div class="form-group col-12 ">
                  <div class="float-right mt-2">
                    <button [disabled]='!isSendEmail'
                      class="btn btn-round btn-geia-info bold-azul bold-azul-geia btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1 btn-block">
                      ENVIAR
                      <i class="bold-azul-geia mr-1"
                        [ngClass]="isLoading  ? 'fa fa fa-refresh fa-spin  fa-fw' : 'fa fa-arrow-right  '"></i>
                    </button>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="feature-section bg-geia-azul">
    <div class="container">
        <div class="row justify-content-center service-looop" >
         <div class="col-lg-12" >
        <div class="section-heading text-center mt-5">
          <h2 class="title" style="color: white; font-weight: 700; font-size: 1.8em !important;"> Sua empresa conta
            com a consultoria <br> especializada da Géia </h2>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-10" >
        <div data-wow-delay="0.3s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
          <div class="icon"><img width="50px"
              src="../../../../assets/app-assets/images/icones-geia/conferencia-w.png"></div>
          <h4 class="title-geia text-white m-t-title"><b>Análise e conferência</b> <p>das faturas</p> </h4>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-10"  >
        <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
          <div class="icon"><img width="50px"
              src="../../../../assets/app-assets/images/icones-geia/intemediacao-w.png" class="cursor-pointer"></div>
          <h4 class="title-geia text-white m-t-title"><b>Intermediação de negociações junto</b> <p>à operadora</p></h4>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-10" >
        <div data-wow-delay="0.5s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
          <div class="icon"><img width="50px" src="../../../../assets/app-assets/images/icones-geia/rh-w.png"
              class="cursor-pointer"></div>
          <h4 class="title-geia text-white m-t-title"><b>Suporte ao RH</b> <p>e movimentação cadastral</p> </h4>
        </div>
      </div> 
          <div class="col-lg-4 col-md-6 col-sm-10" style="margin-top: -4%;" >
            <div data-wow-delay="0.6s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul"
               >
              <div class="icon"><img width="50px" src="../../../../assets/app-assets/images/icones-geia/agendamento-w.png"
                  class="cursor-pointer"></div>
              <h4 class="title-geia text-white m-t-title"><b>Agendamento</b>  <p>de exames e consultas</p></h4>
            </div>
          </div>
          <div *ngIf="heGrandeEmpresa" class="col-lg-4 col-md-6 col-sm-10" style="margin-top: -4%;"  >
            <div data-wow-delay="0.6s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
              <div class="icon"><img width="50px" src="../../../../assets/app-assets/images/icones-geia/colaborador-w.png"
                  class="cursor-pointer"></div>
              <h4 class="title-geia text-white m-t-title"><b>Colaborador </b> in company*</h4><p class="mt-1 text-white"
                style="font-size: 9px;">*Benefícios disponibilizados de acordo com a negociação e volumetria do
                contrato</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-10" style="margin-top: -4%;">
            <div data-wow-delay="0.6s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
              <div class="icon"><img width="50px"
                  src="../../../../assets/app-assets/images/icones-geia/gestao-saude-branco.png" class="cursor-pointer">
              </div>
              <h4 class="title-geia text-white m-t-title"><b>Gestão de Saúde </b><p>e gerenciamento de risco</p></h4>
            </div>
          </div>
         </div>
      </div>  
  </section>
  <app-portal-footer> </app-portal-footer>
</block-ui>